export const styles = {
  tableHeader: {
    fontFamily: "Comfortaa",
    fontSize: 32,
    color: "primary.main",
  },
};
